import React from 'react'
import { Input } from 'antd'
import { observer } from 'mobx-react-lite'
import type { FieldMethods } from '../types'

export interface TextareaInputProps {
    field?: FieldMethods
    index?: number
    disabled?: boolean
    className?: string
    style?: React.CSSProperties
    [key: string]: any
}

export const TextareaInput: React.FC<TextareaInputProps> = observer(({ field, index }) => {
    if (!field) {
        return null
    }

    return <Input.TextArea {...field.bind({ index: index ?? 0 })} />
})
